import KeyboardingAPI from '@/api';

export default {
  async getCurriculum({ commit, state }) {
    const { id: studentId, sessionId } = state;

    if (!sessionId) return;

    const {
      status,
      data: { curriculum, bestResults, position }
    } = await KeyboardingAPI.getCurriculum(sessionId);

    const { stopAndReview: { week: stopAndReviewWeek } = {} } = position;

    if (status < 400) {
      commit('setCurriculum', curriculum);
      commit('setStudent', {
        bestResults,
        position,
        stopAndReviewWeek
      });
    } else {
      commit('application/setModal', { type: 'error' }, { root: true });
    }
  }
};
